import { useCallback, useState } from 'react';
import { FiEdit2, FiSave } from 'react-icons/fi';
import './ProposedDphCell.scss';

const ProposedDphCell = ({ currentDP, proposedDphPrice, onChange, editable }) => {
    const [editing, setEditing] = useState(false);
    const initialValue = proposedDphPrice != null ? Number(proposedDphPrice).toFixed(2) : (currentDP?.toFixed(2) || '0.00');
    const [value, setValue] = useState(initialValue);

    const handleChange = useCallback((e) => {
        setValue(e.target.value);
        onChange?.(e.target.value);
    }, [onChange]);

    const handleSave = useCallback(() => {
        setEditing(false);
    }, []);

    return (
        <div className={`proposed-dph ${editing ? 'editing' : ''}`}>
            {editable && editing ? (
                <>
                    <input
                        type="number"
                        value={value}
                        onChange={handleChange}
                        autoFocus
                    />
                    {editable && <button className="icon-btn save" onClick={handleSave} title="Save">
                        <FiSave />
                    </button>}
                </>
            ) : (
                <>
                    <span className="pill">₹ {value}</span>
                    {editable && (
                        <button className="icon-btn edit" onClick={() => setEditing(true)} title="Edit">
                            <FiEdit2 />
                        </button>
                    )}
                </>
            )}
        </div>
    );
};

export default ProposedDphCell;
